import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
## 📦 Inbuilt Node Modules

The following **Node.js modules** are available by default in both  
**pre-request** and **post-response** scripts:

- \`axios\` – HTTP client for making API requests
- \`lodash\` – Utility functions for data manipulation
- \`chai\` – Assertion library for testing
- \`node-fetch\` – Fetch API for Node.js
- \`http\` – Node.js HTTP module
- \`https\` – Node.js HTTPS module
- \`url\` – URL parsing and formatting utilities

These modules can be used directly inside scripts without any additional setup.
`;

const InbuiltNodeModules = () => {
    return (
        <MarkDownRenderer
            title="Inbuilt Node Modules"
            markDownText={markdownContent}
        />
    );
};

export default InbuiltNodeModules;
